import { Controller } from "@hotwired/stimulus";

// Score stepper: +/- buttons that increment/decrement a numeric input.
// Uses the native stepUp/stepDown methods so step/min/max attributes on the
// input are respected, then dispatches an "input" event so any listeners
// (form-dirty trackers, validation, etc.) see the change.
//
// Connect to: data-controller="score-stepper"
//
// Usage:
//   <div data-controller="score-stepper">
//     <button data-action="click->score-stepper#decrement">−</button>
//     <input type="number" step="1" data-score-stepper-target="input">
//     <button data-action="click->score-stepper#increment">+</button>
//   </div>
export default class extends Controller {
  static targets = ["input"];

  declare readonly inputTarget: HTMLInputElement;

  increment(event: Event) {
    event.preventDefault();
    this.inputTarget.stepUp();
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  decrement(event: Event) {
    event.preventDefault();
    this.inputTarget.stepDown();
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
